<template>
    <div id="page">
        <div class="page-content" style="min-height:400px">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        کارتابل درخواست ها
                        <!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="filter-row-scrollable">
                            <div @click="lstFilter('Ongoing',0)" id="Ongoing" class="filterSelectItem filter-scrollable-box selected">جاری</div>
                            <div @click="lstFilter('NoAction',1)" id="NoAction" class="filterSelectItem filter-scrollable-box">بدون اقدام</div>
                            <div @click="lstFilter('UnderReview',2)" id="UnderReview" class="filterSelectItem filter-scrollable-box">در حال بررسی</div>
                            <div @click="lstFilter('Approved',3)" id="Approved" class="filterSelectItem filter-scrollable-box">تایید شده</div>
                            <div @click="lstFilter('Rejected',4)" id="Rejected" class="filterSelectItem filter-scrollable-box">رد شده</div>
                            <div @click="lstFilter('All',5)" id="All" class="filterSelectItem filter-scrollable-box">همه</div>
                        </div>
                    </div>

                    <!--<div class="input-style input-style-2 input-required has-icon mb-0">
                        <i class="input-icon fa fa-filter color-orange-dark"></i>
                        <em><i class="fa fa-angle-down"></i></em>
                        <select class="form-control" v-model="filterId" autocomplete="off" @change="filterList">
                            <option value="0">جاری</option>
                            <option value="1">بدون اقدام ها</option>
                            <option value="2">درحال بررسی</option>
                            <option value="3">تایید شده</option>
                            <option value="4">رد شده</option>
                            <option value="5">همه</option>
                        </select>
                    </div>-->
                </div>
            </div>

            <div class="main-content-box">
                <div class="card card-style mb-2" v-for="task in TaskCloseList" :key="task.closeRequestId" @click.prevent="openDetails(task.closeRequestId)">
                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div py-2 px-3">
                            <div>
                                <b class="font-13 text-dark">{{task.taskFolderTitle}}</b>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <span class="text-muted text-left ltr d-inline-block">{{task.strRequestDateTime}}</span>
                                </div>
                                <div>
                                    <i class="fa fa-hashtag color-blue2-dark ml-0"></i>
                                    <span class="text-muted">{{task.taskNo}}</span>
                                </div>
                                <div>
                                    <span class="badge font-10 position-static mt-0" :id="'userActionTitleSpan-'+task.closeRequestId" :class="getClassNameForUserActionTitleSpan(task.closeRequestId,task.userActionTitle)">{{task.userActionTitle}}</span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="d-inline-flex align-items-center">
                                    <!--اگر کاربر درخواست دهنده تصویر پروفایل نداشت-->
                                    <!--<i class="fa fa-user-plus color-green2-light ml-0"></i>-->
                                    <!--تصویر پروفایل کاربر درخواست دهنده-->
                                    <img v-if="task.userReferrerImg!=null && task.userReferrerImg!=''" :src="task.userReferrerImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                    <i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>
                                    <span class="text-muted">{{task.userTitle}}</span>
                                </div>
                                <div class="d-inline-flex align-items-center">
                                    <!--اگر کاربر بررسی کننده تصویر پروفایل نداشت-->
                                    <!--<i class="fa fa-user-check color-pink2-dark ml-0"></i>-->
                                    <!--تصویر پروفایل کاربر بررسی کننده-->
                                    <img v-if="task.userReceiverImg!=null && task.userReceiverImg!=''" :src="task.userReceiverImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                    <i v-else class="fa fa-user-circle color-magenta2-dark ml-2 font-30"></i>
                                    <span class="text-muted">{{task.toUserTitle}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskCloseList.length>0&& TaskCloseList.length%10===0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info rounded-m" @click="getNextPageForTaskCloseList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="TaskCloseList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">درخواستی یافت نشد.</p>
                    </div>
                </div>
            </div>
        </div>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">

                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CloseTask', params: { closeRequestId: selectedRequestId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <router-link :to="{ name: 'TaskWorkList', params: { taskFolderId: selectedTaskFolderId,taskId:selectedTaskId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-check-square color-blue2-light float-right font-14"></i>لیست پیگیری ها</span><i class="fa fa-angle-left"></i></router-link>

                </div>
                <div class="clear"></div>
            </div>
        </div>

        <Help-Menu title="راهنمای کارتابل درخواست ها" keyEn="TaskCloseRequest"></Help-Menu>

        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h4 class="modal-title mt-0">جستجو</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">
                        <myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

                        <button type="button" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>



</template>

<script>
    import HelpMenu from '../Components/HelpMenu.vue';
    import MyTeamList from '../Components/MyTeamList.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu,
            "myTeamList": MyTeamList,
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                applicantUserId: null,
                selectedTaskFolderId: 0,
                selectedTaskId: 0,
                selectedRequestId: 0,
                showApplicantUser: false
            };
        },
        computed: {
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            TaskCloseList() {
                return this.$store.getters.GetTaskCloseRequestList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetTaskCloseNoMoreData;
            }
        },
        created() {
            this.filterList();
        },
        methods: {
            selectUser(d) {
                this.applicantUserId = d;
            },
            showMenu(taskFolderId, taskId, requestId) {
                this.selectedTaskFolderId = taskFolderId;
                this.selectedTaskId = taskId;
                this.selectedRequestId = requestId
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {}).then(x => {
                    this.$http.get("Account/GetLogginedUserID")
                        .then(data => {
                            this.applicantUserId = data.data;
                            this.showApplicantUser = true;
                        });
                });
            },
            lstFilter(filterSelect, filterId) {
                this.filterId = filterId;
                var elements = document.getElementsByClassName('filterSelectItem');
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('selected');
                }
                document.getElementById(filterSelect).classList.add('selected');
                this.filterList();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetTaskCloseRequestListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    applicantUserId: this.applicantUserId
                });
            },
            openDetails(requestId) {
                this.$router.push({ name: 'CloseTask', params: { closeRequestId: requestId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForTaskCloseList() {
                this.page++;
                this.$store.dispatch("GetTaskCloseRequestListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    applicantUserId: this.applicantUserId
                });
            },
            pauseVid(id) {
                if (id != null) {
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
            getClassNameForUserActionTitleSpan(closeRequestId, userActionTitle) {
                var classNsme = "";
                userActionTitle = userActionTitle.trim();
                switch (userActionTitle) {
                    case "در حال بررسي":
                        classNsme = "badge-primary";
                        break;
                    case "بدون اقدام":
                        classNsme = "badge-warning text-white";
                        break;

                    default:
                        classNsme = "badge-info";
                }
                return classNsme;
            }
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },

    };</script>
